export default __webpack_public_path__ + "static/media/next-earbuddyzultra.f7f42213.jpg";